import { UploadOutlined } from '@ant-design/icons'
import { Button, Col, Form, message, Row, Select, Upload } from 'antd'
import { useCallback, type FC } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiImportLicenses } from '~/api/adminApi'
import { useSoftwaresQuery } from '~/pages/query'
import { showErrors } from '~/utils/helpers'

interface Props {
  onSuccess: () => void
}

export const LicenseImportForm: FC<Props> = ({ onSuccess }) => {
  const queryClient = useQueryClient()
  const importMutation = useMutation({
    mutationFn: apiImportLicenses,
    onError: showErrors,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['licenses'] })
    }
  })

  const { data: softwares } = useSoftwaresQuery()

  const onSubmit = useCallback(
    (values) => {
      console.log(values)
      importMutation.mutate(values, {
        onSuccess: () => {
          onSuccess()
          message.success('Created successfully')
        }
      })
    },
    [importMutation, onSuccess]
  )

  return (
    <Form layout='vertical' onFinish={onSubmit}>
      <Row>
        <Col span={24}>
          <Form.Item
            name='software_id'
            label='Software'
            rules={[{ required: true }]}
          >
            <Select
              placeholder='Software'
              options={softwares?.map((i) => ({
                value: i.id,
                label: i.name
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name='file'
            label='License file'
            rules={[{ required: true }]}
            getValueFromEvent={(e) => e?.file}
          >
            <Upload
              multiple={false}
              name='file'
              beforeUpload={() => false}
              maxCount={1}
              accept='.xlsx,.csv'
            >
              <Button icon={<UploadOutlined />}>Select license file</Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Button
            type='primary'
            htmlType='submit'
            loading={importMutation.isPending}
            disabled={importMutation.isPending}
          >
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
